import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { formatMoney } from '../../helpers/invoiceHelpers';
import { keys } from './constants';

const ConfirmRefundDialog = ({
  open,
  translate,
  totalTTC,
  locale,
  currency,
  invoiceLabel,
  isSubmitting,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={onCancel} disableEscapeKeyDown maxWidth="xs">
    <DialogTitle>{translate(keys.confirmTitle)}</DialogTitle>
    <DialogContent>
      <DialogContentText component="div">
        {translate(keys.confirmBody, { amount: formatMoney(totalTTC, locale, currency), invoice: invoiceLabel })}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button id="refundByItem-confirm-cancel-button" onClick={onCancel} disabled={isSubmitting}>
        {translate(keys.cancel)}
      </Button>
      <Button
        id="refundByItem-confirm-submit-button"
        onClick={onConfirm}
        color="primary"
        variant="contained"
        disabled={isSubmitting}
      >
        {translate(keys.confirm)}
      </Button>
    </DialogActions>
  </Dialog>
);

ConfirmRefundDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  totalTTC: PropTypes.number,
  locale: PropTypes.string,
  currency: PropTypes.string,
  invoiceLabel: PropTypes.string,
  isSubmitting: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmRefundDialog;
